export const PERSONAL_NUMBER_PATTERN = /^(19|20)(\d{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])(-)?\d{4})$/;
